import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import './styles.css';
import Icon from '../Icon';
import Label from '../Label';
import Tooltip from '../Tooltip';

export default function BasicLabel({
  as,
  icon,
  text,
  size,
  tooltip,
  children,
  className,
  tooltipHeader,
  CustomTooltipIcon,
}) {
  const tooltipRef = useRef();

  return (
    <div className={classNames('basic-label', className)}>
      <Label as={as}>
        {icon && <Icon name={icon} size={size} />}
        {children ? children : text}
      </Label>
      {tooltip && (
        <Tooltip
          className="heading-tooltip"
          contentHeader={tooltipHeader || text}
          contentText={tooltip}
          showCloseBtn
          onClose={() => {
            tooltipRef.current.focus();
          }}
        >
          {CustomTooltipIcon ? (
            <i
              tabIndex="0"
              aria-label="Tooltip"
              ref={tooltipRef}
              className="heading-tooltip-icon-custom"
            >
              <CustomTooltipIcon className="heading-tooltip-icon-custom" />
            </i>
          ) : (
            <i
              className="info circle icon heading-tooltip-icon"
              tabIndex="0"
              aria-label="Tooltip"
              ref={tooltipRef}
            />
          )}
        </Tooltip>
      )}
    </div>
  );
}

BasicLabel.propTypes = {
  as: PropTypes.string,
  icon: PropTypes.string,
  size: PropTypes.string,
  text: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
  CustomTooltipIcon: PropTypes.object,
  tooltip: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  tooltipHeader: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};
